
import React from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import UrlTiedNodeInputField from "../../components/node/nav/UrlTiedNodeInputField";
import LoaderSpinner from "../../components/general/LoadingSpinner";
import NodeNavigation from "../../components/node/nav/NodeNavigation";

import Logo from "../../components/layout/Logo";
import Link from "next/link";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import StorefrontIcon from '@mui/icons-material/Storefront';
import StorageIcon from '@mui/icons-material/Storage';
import MyNodeLink from "../../components/auth/MyNodeLink";
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import ChannelRecommenderLink from "../../components/channel-recommender/ChannelRecommenderLink";
import LooksOneIcon from '@mui/icons-material/LooksOne';
import { ISimpleNode } from "../../components/node/nav/ISimpleNode";



export default function NewNodePage() {
  const [node, setNode] = React.useState<ISimpleNode>();


  return (
    <BaseLayout
      pageTitle="Explore"
      disableOnMaintenance={true}
      bottomMargin={false}
    >
      <NodeNavigation searchField={false} />

      <div className="pt-12" style={{ minHeight: '60vh' }}>

        <div className="flex flex-col items-center">
          <div className="pb-12 flex items-center">
            <Logo size="32px" /> <span className="text-3xl pl-2">LnRouter</span><span className="pl-1 self-end">Explore</span>
          </div>

        </div>

        <div>
          {!node &&
            <div className=" px-2">
              <UrlTiedNodeInputField size="big" className="mx-auto" autoFocus={true} onChange={value => setNode(value)} />
            </div>
          }


          {node &&
            <div>
              <div className="text-center font-bold text-2xl">
                {node.label}
              </div>
              <div className="pt-1">
              <LoaderSpinner width={50} height={20}/>
              </div>
              
            </div>
          }
        </div>
        <div className="py-36 lnrouter-container grid grid-cols-1 sm:grid-cols-2  xl:grid-cols-4 md:grid-cols-3 gap-4">
        <Link href="/node-ranking">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                <LooksOneIcon fontSize="inherit" color="inherit" className="mr-2 text-xl" />
                Node Ranking
              </div>
            </a>
          </Link>
          <ChannelRecommenderLink>
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                <AccountTreeIcon fontSize="inherit" color="inherit" className="mr-2 text-xl" />
                Channel Recommender
              </div>
            </a>
          </ChannelRecommenderLink>
          <Link href="/liquidity-ads">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                <StorefrontIcon fontSize="inherit" color="inherit" className="mr-2 text-xl" />
                Liquidity Ad Marketplace
              </div>
            </a>
          </Link>
          <MyNodeLink>
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                <StorageIcon fontSize="inherit" color="inherit" className="mr-2 text-xl" />
                My node
              </div>
            </a>
          </MyNodeLink>
          <Link href="/graph">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                <BubbleChartIcon fontSize="inherit" color="inherit" className="mr-2 text-xl" />
                Lightning Graph
              </div>
            </a>
          </Link>

          <Link href="/get-route">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                Shortest Path
              </div>
            </a>
          </Link>

          <Link href="/channel-id-converter">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                Channel ID converter
              </div>
            </a>
          </Link>

          <Link href="/scores/terminal">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                Terminal Score Debugger
              </div>
            </a>
          </Link>

          <Link href="/graph/zero-base-fee">
            <a>
              <div className=" bg-white border p-4 rounded hover:border-viking-300 text-x font-bold shadow-br">
                #zeroBaseFee Graph
              </div>
            </a>
          </Link>

        </div>

      </div>


    </BaseLayout>
  );
}

